import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";

export interface RoleFeature {
  id: number;
  name: string;
  isCreatePost: boolean;
  isCreateReel: boolean;
  isCreateOpenCall: boolean;
  isPostAuditionVideo: boolean;
  isGoLive: boolean;
  isJoinLive: boolean;
  isSubscriptionRequired: boolean;
  createdAt: number;
}

interface RoleFeaturesResponse {
  statusCode: number;
  message: string;
  data: RoleFeature[];
}

interface SingleRoleFeatureResponse {
  statusCode: number;
  message: string;
  data: RoleFeature;
}

// fetch all role features
export const fetchRoleFeatures = async (): Promise<RoleFeaturesResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/role-features`,
  );
  return response;
};

// update role feature
export const updateRoleFeature = async (
  roleId: number,
  featureData: Partial<RoleFeature>,
): Promise<SingleRoleFeatureResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.patch(
    `${process.env.REACT_APP_ADMIN_API_URL}/role-features/${roleId}`,
    featureData,
  );
  return response;
};
